import { createProgramListSlice } from './programList.slice';
import {
  fetchJoiningBonusPrograms,
  fetchJoiningBonusProgramById,
} from './JoiningBonusProgram.api';

export const JOINING_BONUS_PROGRAM_STATE_KEY = 'joiningBonusProgram';

export const joiningBonusProgramSlice = createProgramListSlice(
  'JOINING_BONUS_PROGRAM',
  { fetch: fetchJoiningBonusPrograms, fetchOne: fetchJoiningBonusProgramById },
  JOINING_BONUS_PROGRAM_STATE_KEY,
);
